import dayjs from 'dayjs';
import dexieDb, { IndexedDbObjectModel } from '@/composables/useIndexedDb';

export const IndexedDbRepository = () => {
  // 最大10回までリトライする
  const MAX_RETRY_COUNT = 10;

  /** データ取得 */
  const get = async (key: string): Promise<IndexedDbObjectModel | undefined> => {
    let retryCount = 0;
    const loop = async () => {
      try {
        return await dexieDb.tbsChannelApp.get(key);
      } catch (e) {
        if (retryCount >= MAX_RETRY_COUNT) {
          throw new Error(`FAIL TO GET ${key} VALUE: ${e}`);
        }
        retryCount++;
        await new Promise((resolve) => setTimeout(resolve, 100));
        await loop();
      }
    };
    return await loop();
  };

  /** データ作成・更新 */
  const save = async (dbObject: IndexedDbObjectModel): Promise<void> => {
    let retryCount = 0;
    const loop = async () => {
      try {
        await dexieDb.tbsChannelApp.put(dbObject);
      } catch (e) {
        if (retryCount >= MAX_RETRY_COUNT) {
          throw new Error(`FAIL TO SAVE ${dbObject.key} VALUE: ${e}`);
        }
        retryCount++;
        await new Promise((resolve) => setTimeout(resolve, 100));
        await loop();
      }
    };
    await loop();
  };

  /** データ削除 */
  const remove = async (key: string) => {
    let retryCount = 0;
    const loop = async () => {
      try {
        return await dexieDb.tbsChannelApp.delete(key);
      } catch (e) {
        if (retryCount >= MAX_RETRY_COUNT) {
          throw new Error(`FAIL TO REMOVE ${key} VALUE: ${e}`);
        }
        retryCount++;
        await new Promise((resolve) => setTimeout(resolve, 100));
        await loop();
      }
    };
    await loop();
  };

  /** 登録済みのプライマリキーを全て取得 */
  const getAllKeys = async (): Promise<string[] | undefined> => {
    let retryCount = 0;
    const loop = async () => {
      try {
        return await dexieDb.tbsChannelApp.toCollection().primaryKeys();
      } catch (e) {
        if (retryCount >= MAX_RETRY_COUNT) {
          throw new Error(`FAIL TO GET INDEXED_DB PRIMARY_KEY VALUE: ${e}`);
        }
        retryCount++;
        await new Promise((resolve) => setTimeout(resolve, 100));
        await loop();
      }
    };
    return await loop();
  };

  /** 先月以前の番組表JSONか、キー名から判定 */
  const isExpiredProgramsKey = (key: string) => {
    // キーに含まれる6桁の数字を抽出
    const date = key.match(/\d{6}/g);
    const _isExpired = (dateString: string) => dayjs(dateString).isBefore(dayjs().format('YYYYMM'));
    return !!date && _isExpired(date[0]);
  };

  return {
    get,
    save,
    remove,
    getAllKeys,
    isExpiredProgramsKey,
  };
};
